export type JobsApiItem = {
  id: string;
  title: string;
  description: string;
  company: string;
  location: string;
  url: string;
  posted_date: string;
  aggregator_name: string;
  salary_min: number | null;
  salary_max: number | null;
  salary_curr: string | null;
  cost_model_cpa: number | null;
  cost_model_cpc: number | null;
  cpa_value: number | null;
  cpc_value: number | null;
  country: string | null;
  city: string | null;
  state: string | null;
  ref_id: string | null;
  aggregator_id: string | null;
  category: string[];
  job_type: string | null;
  skills: string[];
  keywords: string[];
  logo: string;
  feed_id: string;
};

export type JobsApiResponse = {
  items: JobsApiItem[];
  total: number;
  limit: number;
  offset: number;
  has_more: boolean;
};

export const JOB_PROVIDER = {
  JOOBLE: 'jooble',
  JOBRAPIDO: 'jobrapido',
  WHATJOB: 'whatjob',
  WHATJOBS: 'whatjobs',
  ADZUNA: 'adzuna',
  APPCAST: 'appcast',
  TALROO: 'talroo',
  CPA: 'cpa',
} as const;

export type JobProvider = typeof JOB_PROVIDER[keyof typeof JOB_PROVIDER];
